import { Button, mergeClasses, Tooltip } from "@fluentui/react-components";
import { AttachIcon } from "icons/AttachIcon";
import { ALLOWED_FILE_EXTENSIONS, ConstantValues } from "common/constants";
import { FileWithId } from "models/FileWithId";
import { useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { useSharedButtonStyles } from "theme/sharedStyles";
import { useFileUploaderStyles } from "./FileUploader.styles";
import { IFileUploaderProps } from "./FileUploader.types";

export const FileUploader = (props: IFileUploaderProps) => {
  const sharedButtonStyles = useSharedButtonStyles();
  const styles = useFileUploaderStyles();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const selectFileFromOS = () => fileInputRef.current?.click();

  const handleClick = (event: any) => {
    const { target = {} } = event || {};
    target.value = ConstantValues.EMPTY_STRING;
  };

  const handleFileInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files: File[] = event.target.files
      ? Array.from(event.target.files)
      : [];
    if (!files.length) return;

    const allowedExtensions = ALLOWED_FILE_EXTENSIONS.map((ext) =>
      ext.toLowerCase(),
    );
    const newFiles: FileWithId[] = [];

    files.forEach((file: File): void => {
      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      if (fileExtension === "pptx" || fileExtension === "ppt") {
        props.setUnsupportedFileMessage(
          `PPT/PPTX files are not supported. Please save the file as a PDF and then upload the PDF.`,
        );

        return;
      }

      if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
        props.setUnsupportedFileMessage(
          `The file "${file.name}" is not supported by AIMS. Only these file types are allowed: ${ALLOWED_FILE_EXTENSIONS.join(", ")}`,
        );

        return;
      }

      newFiles.push({ file, id: uuidv4() });
    });

    if (newFiles.length > 0) {
      props.onFileSelect(newFiles);
    }
  };

  return (
    <>
      <input
        onChange={handleFileInputChange}
        onClick={handleClick}
        multiple={true}
        ref={fileInputRef}
        type="file"
        hidden
      />
      <Tooltip
        content={`Supported file types for document upload: ${ALLOWED_FILE_EXTENSIONS.join(", ")}`}
        relationship="description"
      >
        <Button
          icon={<AttachIcon size={16} />}
          onClick={selectFileFromOS}
          className={mergeClasses(
            sharedButtonStyles.ghostButton,
            styles.button,
          )}
          aria-label="Attach file"
        />
      </Tooltip>
    </>
  );
};
